// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__IaYAB","summary":"CartItem_summary__GtaUF","price":"CartItem_price__iItiR","quantity":"CartItem_quantity__Y4ZGm","actions":"CartItem_actions__6hKY8"};